// extracted by mini-css-extract-plugin
export default {"modal":"OrderAssistance_modal__HjAf4","btn":"OrderAssistance_btn__GMVJJ"};